// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2R3De","title":"ClientCherryInfo_title__2-a7P","itemText":"ClientCherryInfo_itemText__T9f-U"};